var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 184,
    viewBox: "0 0 180 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 180.44C139.706 180.44 180 140.146 180 90.4404C180 40.7348 139.706 0.44043 90 0.44043C40.2944 0.44043 0 40.7348 0 90.4404C0 140.146 40.2944 180.44 90 180.44Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7459_41541)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7459_41541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 181
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 180.44C139.706 180.44 180 140.146 180 90.4404C180 40.7348 139.706 0.44043 90 0.44043C40.2944 0.44043 0 40.7348 0 90.4404C0 140.146 40.2944 180.44 90 180.44Z",
    fill: "url(#paint0_linear_7459_41541)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7459_41541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.6 52.04H38.3999C35.0862 52.04 32.3999 54.7263 32.3999 58.04V184.04C32.3999 187.354 35.0862 190.04 38.3999 190.04H141.6C144.914 190.04 147.6 187.354 147.6 184.04V58.04C147.6 54.7263 144.914 52.04 141.6 52.04Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1999 64.04H47.9999C46.0117 64.04 44.3999 65.6518 44.3999 67.64C44.3999 69.6283 46.0117 71.24 47.9999 71.24H79.1999C81.1881 71.24 82.7999 69.6283 82.7999 67.64C82.7999 65.6518 81.1881 64.04 79.1999 64.04Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1999 114.44H47.9999C46.0117 114.44 44.3999 116.052 44.3999 118.04C44.3999 120.029 46.0117 121.64 47.9999 121.64H79.1999C81.1881 121.64 82.7999 120.029 82.7999 118.04C82.7999 116.052 81.1881 114.44 79.1999 114.44Z",
    fill: "#EAECF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.6 82.04H50.3996C47.7486 82.04 45.5996 84.1891 45.5996 86.84V98.84C45.5996 101.491 47.7486 103.64 50.3996 103.64H129.6C132.251 103.64 134.4 101.491 134.4 98.84V86.84C134.4 84.1891 132.251 82.04 129.6 82.04Z",
    stroke: "#98A2B3",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0625 97.5156H67.668L67.5391 94.5273L70.0117 96.0859L70.8086 94.8438L68.0898 93.4023L70.8086 91.9727L70.0117 90.7305L67.5391 92.2891L67.668 89.3008H66.0625L66.1914 92.3008L63.707 90.7305L62.9102 91.9727L65.6289 93.4023L62.9102 94.8438L63.707 96.0859L66.1914 94.5156L66.0625 97.5156ZM77.3828 97.5156H78.9883L78.8594 94.5273L81.332 96.0859L82.1289 94.8438L79.4102 93.4023L82.1289 91.9727L81.332 90.7305L78.8594 92.2891L78.9883 89.3008H77.3828L77.5117 92.3008L75.0273 90.7305L74.2305 91.9727L76.9492 93.4023L74.2305 94.8438L75.0273 96.0859L77.5117 94.5156L77.3828 97.5156ZM88.7031 97.5156H90.3086L90.1797 94.5273L92.6523 96.0859L93.4492 94.8438L90.7305 93.4023L93.4492 91.9727L92.6523 90.7305L90.1797 92.2891L90.3086 89.3008H88.7031L88.832 92.3008L86.3477 90.7305L85.5508 91.9727L88.2695 93.4023L85.5508 94.8438L86.3477 96.0859L88.832 94.5156L88.7031 97.5156ZM100.023 97.5156H101.629L101.5 94.5273L103.973 96.0859L104.77 94.8438L102.051 93.4023L104.77 91.9727L103.973 90.7305L101.5 92.2891L101.629 89.3008H100.023L100.152 92.3008L97.668 90.7305L96.8711 91.9727L99.5898 93.4023L96.8711 94.8438L97.668 96.0859L100.152 94.5156L100.023 97.5156ZM111.344 97.5156H112.949L112.82 94.5273L115.293 96.0859L116.09 94.8438L113.371 93.4023L116.09 91.9727L115.293 90.7305L112.82 92.2891L112.949 89.3008H111.344L111.473 92.3008L108.988 90.7305L108.191 91.9727L110.91 93.4023L108.191 94.8438L108.988 96.0859L111.473 94.5156L111.344 97.5156Z",
    fill: "#98A2B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.6 131.24H50.3999C47.0862 131.24 44.3999 133.927 44.3999 137.24V146.84C44.3999 150.154 47.0862 152.84 50.3999 152.84H129.6C132.914 152.84 135.6 150.154 135.6 146.84V137.24C135.6 133.927 132.914 131.24 129.6 131.24Z",
    fill: "#AA79B4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7459_41541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 22.6998L95.4 18.7998L94.1 20.2998L98.7 24.1998L100 22.6998ZM85.9 20.3998L84.6 18.8998L80 22.6998L81.3 24.1998L85.9 20.3998ZM90.5 24.9998H89V30.9998L93.7 33.8998L94.5 32.6998L90.5 30.2998V24.9998ZM90 20.9998C85 20.9998 81 24.9998 81 29.9998C81 34.9998 85 38.9998 90 38.9998C95 38.9998 99 34.9998 99 29.9998C99 24.9998 95 20.9998 90 20.9998ZM90 36.9998C86.1 36.9998 83 33.8998 83 29.9998C83 26.0998 86.1 22.9998 90 22.9998C93.9 22.9998 97 26.0998 97 29.9998C97 33.8998 93.9 36.9998 90 36.9998Z",
    fill: "#98A2B3"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141 101.44H163L152 82.4404L141 101.44ZM153 98.4404H151V96.4404H153V98.4404ZM153 94.4404H151V90.4404H153V94.4404Z",
    fill: "#FFB547"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7459_41541",
    x: 26.3999,
    y: 43.04,
    width: 127.2,
    height: 140.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7459_41541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7459_41541",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7459_41541",
    x1: 90,
    y1: 0.44043,
    x2: 90,
    y2: 180.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7459_41541"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 17,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordExpired);
export default __webpack_public_path__ + "static/media/password_expired.67374ccc5500512f873378292ebd1ea2.svg";
export { ForwardRef as ReactComponent };